import { type SavedConfigurationDTO } from "./dtos";
import { type SavedConfiguration } from "./models";
import { transformToExternalUrl } from "../common/translationUtils";
import { ConfiguratorType, getConfiguratorTypeFromProductCode } from "~/Configurators/ConfiguratorType";

export function transformSavedConfig(dto: SavedConfigurationDTO[]): SavedConfiguration[] {
  return dto.map(transformSingle);
}

const transformSingle = (dto: SavedConfigurationDTO): SavedConfiguration => {
  const sapMaterialId = dto.schaefflerId ?? "";
  const configuratorType = getConfiguratorTypeFromProductCode(sapMaterialId);
  const isOldConfigurator = configuratorType === ConfiguratorType.System;
  const shortDescription = dto.shortDescription ?? "";

  return {
    ...dto,
    name: dto.name || "",
    schaefflerId: sapMaterialId,
    manufacturerUrl: dto.manufacturerUrl || "",
    shortDescription: isOldConfigurator
      ? resolvePotentiallyExternalLabel(shortDescription, dto.baseExternalUrl)
      : shortDescription,
    useXmlTranslation: !isOldConfigurator,
    isSelected: false,
    showComment: dto.showComment ?? false,
    comment: dto.comment ?? "",
    importUrlPrefix: dto.importUrlPrefix ?? "",
  };
};

export function resolvePotentiallyExternalLabel(label: string, baseExternalUrl: string) {
  return label.toLowerCase().startsWith("http") ? label : transformToExternalUrl(label, baseExternalUrl);
}
